/**
 * Single source of truth for company-branding dimensions in the React app.
 *
 * Logo height is locked to 0.5 in (= 48 px @ 96 DPI) across every surface
 * (Login, AppLayout sidebar, PreOnboarding portal, letter-template preview).
 * Width follows the natural aspect ratio — never set a fixed width.
 *
 * Keep this in sync with backend/app/core/branding.py.
 */

export const LOGO_HEIGHT_PX = 48;

/** Tailwind class for a 48 × 48 square (text-badge variant). */
export const LOGO_BOX_CLASS = "h-12 w-12";

/** Tailwind class for an image logo — fixed height, width follows aspect. */
export const LOGO_IMG_CLASS = "h-12 w-auto";
